import React from 'react';
import {
    Slider, 
    InputNumber,
    Modal
} from 'antd';
import "./index.css";
import "antd/dist/antd.css";

const ModalDetail = ({
    janCode,
    categoryId,
    idPrd,
    dataInit,
    visible,
    setVisible,
    inputValue,
    submitChangePacking
}) => {

    const [dataModal, setDatModal] = React.useState(inputValue)

    const styleModal = {
        width: '100%',
        height: 209,
        justifyContent: 'center',
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column'
    };
    const styleSlide = {
        width: 300,
        marginBottom: 15
    };
    const handleStyles = {
        position: 'absolute',
        bottom: -2,
        width: 16,
        height: 16,
        transform: `rotate(${145}deg)`,
        backgroundColor: '#09D3B7',
        borderRadius: 0,
        borderColor: 'white',
    };

    const trackStyles = {
        backgroundColor: '#09D3B7'
    };

    React.useEffect(() => {

        if(!visible){
            setDatModal(dataInit);
        }
        setDatModal(inputValue);
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataInit, inputValue]);
    
    const onChange = e => {

        if (e > 9999) {
            return setDatModal(9999);
        }
        setDatModal(e);
    };

    return (
        <Modal
            bodyStyle={styleModal}
            className="newStyle"
            centered
            closable={false}
            visible={visible}
            footer={null}
            onCancel={() => {
                setVisible(!visible)
                setDatModal(dataInit)
            }}
        >
            <div style={styleSlide}>
                <Slider
                    trackStyle={trackStyles}
                    handleStyle={handleStyles}
                    step={1}
                    min={1}
                    max={999}
                    onChange={onChange}
                    value={typeof dataModal === 'number' ? dataModal : 1}
                />
                
            </div>

            <div className="style-text">
                <p className="text-packing">重量：</p>
                <p className="text-packing value">{(dataModal ? dataModal : '') + 'グラム'}</p>
            </div>

            <div className="style-text input">
                <p className="text-packing input">購入した重量の入力：</p>
                <InputNumber
                    className="ant-input"
                    min={1}
                    max={9999}
                    style={{ margin: '0 10px', marginBottom: 14, width: 100, height: 21.5, borderBottom: '1px solid #C6C6C8' }}
                    value={dataModal}
                    // disabled={inputValue > 9999? true : false}
                    onChange={onChange}
                    bordered={false}
                    type='number'
                    // maxLength="4"
                    size="small"
                />
            </div>
            <div
                onClick={() => dataModal ? submitChangePacking(janCode, categoryId, idPrd, dataModal) : null}
                className={!dataModal ? "btn-bottom-not-submit" : "btn-bottom-submit"} >
                <h6 className="text-submits">確定</h6>
            </div>
        </Modal>
    );
};

export default ModalDetail;

